import React, { useState } from 'react';
import { Modal, Button, Form, Message } from 'semantic-ui-react';

interface DuplicateContractModalProps {
  open: boolean;
  onCancel: () => void;
  onContinue: (reason: string) => void;
  duplicateContract: any;
}

export const DuplicateContractModal: React.FC<DuplicateContractModalProps> = ({
  open,
  onCancel,
  onContinue,
  duplicateContract
}) => {
  const [duplicateReason, setDuplicateReason] = useState('');
  const [error, setError] = useState('');

  const handleContinue = () => {
    if (!duplicateReason.trim()) {
      setError('Por favor, informe o motivo para criar este contrato duplicado.');
      return;
    }

    onContinue(duplicateReason);
    setDuplicateReason('');
    setError('');
  };

  const handleCancel = () => {
    setDuplicateReason('');
    setError('');
    onCancel();
  };

  return (
    <Modal open={open} onClose={handleCancel} size="small">
      <Modal.Header>⚠️ Contrato Duplicado Detectado</Modal.Header>
      <Modal.Content>
        <Message warning>
          <Message.Header>Atenção - Cliente com Contrato Recente!</Message.Header>
          <p>
            <strong>Este cliente já possui um contrato criado nas últimas 24 horas.</strong>
          </p>
          <p style={{ marginTop: '0.5rem' }}>
            Antes de criar um novo contrato, verifique se o problema não pode ser resolvido
            tentando baixar novamente o contrato existente.
          </p>
        </Message>

        {duplicateContract && (
          <div style={{ marginTop: '1rem', marginBottom: '1.5rem', padding: '1rem', background: '#f9f9f9', borderRadius: '4px' }}>
            <p><strong>Contrato existente:</strong></p>
            <ul style={{ marginTop: '0.5rem' }}>
              <li><strong>ID:</strong> {duplicateContract.id}</li>
              <li><strong>Tipo:</strong> {duplicateContract.tipoContratacao}</li>
              <li><strong>Status:</strong> {duplicateContract.status}</li>
              <li><strong>Criado em:</strong> {new Date(duplicateContract.createdAt).toLocaleString('pt-BR')}</li>
            </ul>
          </div>
        )}

        <Form>
          <Form.TextArea
            label="Motivo para criar contrato duplicado"
            placeholder="Ex: Cliente solicitou novo contrato, erro no download anterior, etc."
            value={duplicateReason}
            onChange={(e) => {
              setDuplicateReason(e.target.value);
              setError('');
            }}
            error={error ? { content: error, pointing: 'above' } : false}
            required
          />
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={handleCancel} color="grey">
          Cancelar e Trocar de Cliente
        </Button>
        <Button primary onClick={handleContinue}>
          Continuar com Novo Contrato
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

